"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var utils = _interopRequireWildcard(require("../../shared"));

var _Avatar = _interopRequireDefault(require("../Avatar/Avatar"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

require("./Notifications.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Component to display a single notification
*/
function NotificationsItem(_ref) {
  var Component = _ref.componentEl,
      avatar = _ref.avatar,
      icon = _ref.icon,
      timestamp = _ref.timestamp,
      initials = _ref.initials,
      children = _ref.children,
      nohover = _ref.nohover,
      highlight = _ref.highlight,
      padding = _ref.padding,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "avatar", "icon", "timestamp", "initials", "children", "nohover", "highlight", "padding"]);

  var cssClasses = ['st_notification'];
  cssClasses = utils.spacing.addSpacingClasses({
    padding: padding,
    cssClasses: cssClasses
  });
  if (highlight) cssClasses.push('st_notification--highlight');
  if (nohover) cssClasses.push('st_notification--nohover');
  if (!avatar && !initials) cssClasses.push('st_notification--noavatar');
  if (!icon) cssClasses.push('st_notification--noicon');
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), (avatar || initials) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_notification__avatar"
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatar: avatar,
    initials: initials,
    margin: {
      top: 'sm'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_notification__text"
  }, children), timestamp && /*#__PURE__*/_react["default"].createElement("time", {
    className: "st_notification__time"
  }, timestamp), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: icon === true ? 'caret-right' : icon,
    className: "st_notification__icon"
  }));
} // proptypes definitions


NotificationsItem.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** url to avatar, if available */
  avatar: _propTypes["default"].string,

  /** timestamp for event */
  timestamp: _propTypes["default"].string,

  /** whether component should look highlighted */
  highlight: _propTypes["default"].bool,

  /** fallback initials for avatar */
  initials: _propTypes["default"].string,

  /** optional icon to show on right, defaults to caret if no icon type specified */
  icon: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),

  /** whether to suppress hover for this item */
  nohover: _propTypes["default"].bool,

  /** padding for item. Setting this overrides defaults and does not extend them */
  padding: utils.spacing.paddingProps
}; // default props

NotificationsItem.defaultProps = {
  componentEl: utils.componentEl.defaults,
  avatar: null,
  highlight: false,
  timestamp: null,
  initials: null,
  icon: false,
  nohover: false,
  padding: {
    vertical: 'sm',
    horizontal: 'mlg'
  }
};
NotificationsItem.displayName = 'Notifications.Item';
var _default = NotificationsItem;
exports["default"] = _default;